import { render, staticRenderFns } from "./AttendanceSubject.vue?vue&type=template&id=b60fd1da"
import script from "./AttendanceSubject.vue?vue&type=script&lang=js"
export * from "./AttendanceSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports